/**
 * Email unsubscribe, served by the Ivipass client site inside kv_backend at
 * `/api/ivipass/unsubscribe`.
 *
 * NOTE: in the source system the unsubscribe list was written but never read
 * before sending. The Ivipass backend must check it in the campaign dispatcher
 * (PLAN B3.3).
 */
import { apiUrl, JSON_HEADERS, handleResponse, buildQuery, exportToCSV } from './env';

export const ENDPOINTS = {
  SUBMIT_UNSUBSCRIBE: '/unsubscribe',
  UNSUBSCRIBES: '/unsubscribes',
};

const makeRequest = async (url, options = {}) => {
  const response = await fetch(url, {
    ...options,
    headers: { ...JSON_HEADERS, ...(options.headers || {}) },
  });
  return handleResponse(response);
};

export const unsubscribeApiUtils = {
  makeRequest,
  buildQueryString: buildQuery,
  exportToCSV,
};

export const unsubscribeService = {
  submitUnsubscribe: async (email) =>
    makeRequest(apiUrl(ENDPOINTS.SUBMIT_UNSUBSCRIBE), {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),

  getUnsubscribes: async (options = {}) => {
    const query = buildQuery({
      page: options.page || 1,
      limit: options.limit || 500,
      email: options.email,
      startDate: options.startDate,
      endDate: options.endDate,
    });
    return makeRequest(`${apiUrl(ENDPOINTS.UNSUBSCRIBES)}?${query}`, { method: 'GET' });
  },

  deleteUnsubscribes: async (unsubscribeIds) =>
    makeRequest(apiUrl(ENDPOINTS.UNSUBSCRIBES), {
      method: 'DELETE',
      body: JSON.stringify({ unsubscribeIds }),
    }),
};

export default unsubscribeService;
